import { render, staticRenderFns } from "./ListDelivery.vue?vue&type=template&id=84a57874"
import script from "./ListDelivery.vue?vue&type=script&lang=js"
export * from "./ListDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListDelivery.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84a57874')) {
      api.createRecord('84a57874', component.options)
    } else {
      api.reload('84a57874', component.options)
    }
    module.hot.accept("./ListDelivery.vue?vue&type=template&id=84a57874", function () {
      api.rerender('84a57874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListDelivery.vue"
export default component.exports